
import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import RelevanceInput from "@/components/RelevanceInput";
import BatchProcessor from "@/components/BatchProcessor";
import EnrichmentQueue from "@/components/enrichment/EnrichmentQueue";
import { Investor } from "@/types/investor";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface InvestorProcessingProps {
  investors: Investor[];
  isAnalyzing: boolean;
  isProcessingBatch: boolean;
  processedCount: number;
  relevanceContext: string;
  setRelevanceContext: (context: string) => void;
  onRelevanceSubmit: (context: string) => Promise<void>;
  onProcessBatch: (batchSize: number) => Promise<void>;
  isInvestorProcessed: (investor: Investor) => boolean;
  pendingSaveCount?: number;
}

const InvestorProcessing = ({
  investors,
  isAnalyzing,
  isProcessingBatch,
  processedCount,
  relevanceContext,
  setRelevanceContext,
  onRelevanceSubmit,
  onProcessBatch,
  isInvestorProcessed,
  pendingSaveCount = 0
}: InvestorProcessingProps) => {
  const [activeTab, setActiveTab] = useState("legacy");

  return (
    <Card>
      <CardHeader>
        <CardTitle>Investor Processing</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <RelevanceInput
          relevanceContext={relevanceContext}
          setRelevanceContext={setRelevanceContext}
          onRelevanceSubmit={onRelevanceSubmit}
          isLoading={isAnalyzing}
        />

        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="legacy">Legacy Processing</TabsTrigger>
            <TabsTrigger value="queue">Queue Processing</TabsTrigger>
          </TabsList>
          
          <TabsContent value="legacy" className="mt-4">
            <BatchProcessor
              investors={investors}
              processedCount={processedCount}
              isProcessing={isProcessingBatch}
              onProcessBatch={onProcessBatch}
              isInvestorProcessed={isInvestorProcessed}
              pendingSaveCount={pendingSaveCount}
            />
          </TabsContent>
          
          <TabsContent value="queue" className="mt-4">
            <EnrichmentQueue
              investors={investors}
              relevanceContext={relevanceContext}
              isInvestorProcessed={isInvestorProcessed}
              onJobComplete={() => {
                // Optionally trigger a data refresh here
                console.log('Enrichment job completed');
              }}
            />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default InvestorProcessing;
